import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '~/redux/hooks';
import { commonActions } from '~/thunks/common/commonSlice';
import { QUEUE_STATUS_FAILED, QUEUE_STATUS_PROCESS, QUEUE_STATUS_SUCCESS } from '~/utils/constants/common';
import { notify } from '~/utils/helper';
import { IQueue } from '~/utils/interface/common';

type ProcessProps = {
  handler: () => Promise<any>;
  processTitle?: string;
  successTitle?: string;
  errorTitle?: string;
  processNotify?: string;
  successNotify?: string;
  errorNotify?: string;
  navigateUrl?: string;
};

const useQueue = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation('admin/common');
  const dispatch = useAppDispatch();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook

  //#endregion Implement Hook

  //#region Handle Function
  const process = async (input: ProcessProps) => {
    let queue: IQueue = {
      id: Date.now(),
      title: input.processTitle ?? t('admin/common:queue.processTitle'),
      status: QUEUE_STATUS_PROCESS,
      isRead: false,
      navigateUrl: input.navigateUrl,
    };

    try {
      dispatch(commonActions.setQueue(queue));
      notify('warning', String(input.processNotify ?? queue.title), { toastId: `queue-process-${queue.id}` });

      await input.handler();

      queue.status = QUEUE_STATUS_SUCCESS;
      queue.title = input.successTitle ?? t('admin/common:queue.successTitle');
      queue.isRead = false;
      dispatch(commonActions.setQueue(queue));

      notify('success', String(input.successNotify ?? queue.title), { toastId: `queue-success-${queue.id}` });
    } catch (e) {
      console.error(e);
      queue.status = QUEUE_STATUS_FAILED;
      queue.title = input.errorTitle ?? t('admin/common:queue.errorTitle');
      queue.isRead = false;
      dispatch(commonActions.setQueue(queue));

      notify('error', String(input.errorNotify ?? queue.title), { toastId: `queue-error-${queue.id}` });
    }
  };
  //#endregion Handle Function

  return { process };
};

export default useQueue;
